import Head from 'next/head'

import type { ReactElement } from 'react'

type JsonLdProps = {
  /** Unique per script on a page, lets `next/head` de-duplicate re-renders. */
  id: string
  data: Record<string, unknown>
}

/**
 * Renders a schema.org block. Serialised with `JSON.stringify` (no HTML entity
 * encoding of `&`) and with `<` escaped so the payload cannot close the script tag.
 */
export function JsonLd({ id, data }: JsonLdProps): ReactElement {
  return (
    <Head>
      <script
        type="application/ld+json"
        key={`jsonld-${id}`}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            ...data,
          }).replaceAll('<', '\\u003c'),
        }}
      />
    </Head>
  )
}
